module.exports = __webpack_public_path__ + "img/0Q3A5746_FoamcoreMatted.fdac43bc.jpg";